"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _emotion = require("emotion");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _find2 = _interopRequireDefault(require("lodash/find"));

var _padStart = _interopRequireDefault(require("lodash/padStart"));

var _timePicker = _interopRequireDefault(require("@amzn/meridian-tokens/component/time-picker"));

var _clock = _interopRequireDefault(require("@amzn/meridian-tokens/base/icon/clock"));

var _alertErrorSmall = _interopRequireDefault(require("@amzn/meridian-tokens/base/icon/alert-error-small"));

var _uniqueId = _interopRequireDefault(require("lodash/uniqueId"));

var _timeParts = require("./time-parts");

var _input = _interopRequireDefault(require("../input"));

var _mask = _interopRequireDefault(require("../input/mask"));

var _timePickerPopover = _interopRequireDefault(require("./time-picker-popover"));

var _timePickerOptions = _interopRequireDefault(require("./time-picker-options"));

var _timePickerInvalidPopover = _interopRequireDefault(require("./time-picker-invalid-popover"));

var _inputMonospacePlaceholder = _interopRequireDefault(require("../_input-monospace-placeholder"));

var _theme = require("../theme");

var _dateLocales = _interopRequireDefault(require("./../_utils/date-locales"));

var _token = require("./../_utils/token");

var _filterPropsByPrefix = _interopRequireDefault(require("./../_utils/filter-props-by-prefix"));

var _supportTextWrapper = _interopRequireDefault(require("../_support-text-wrapper"));

var _getSupportTextAriaDescribedby = _interopRequireDefault(require("./../_utils/get-support-text-aria-describedby"));

var _functional = require("./../_utils/functional");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var inputStyles = (0, _token.memoizeTokenStyles)(function (t, _ref) {
  var focus = _ref.focus,
      filled = _ref.filled;
  return (0, _emotion.css)({
    letterSpacing: focus || filled ? t("inputValueLetterSpacing") : undefined,
    // HACK: We only accept dates in English numerals for now - since we don't yet
    // support other locale numerals, eg: ١،٢،٣،٤،٥،٦،٨،٩،٠ 一，二，三，四，五, etc.
    // Dates entered in English numerals are read and typed LTR.
    direction: "ltr"
  });
}, ["focus", "filled"]);
var widthStyles = (0, _functional.memoizeByKeys)(function (_ref2) {
  var width = _ref2.width;
  return (0, _emotion.css)({
    width: width,
    // If an explicit width is set then don't allow the textarea to flex
    flex: width ? "none !important" : undefined
  });
}, ["width"]);
var placeholderChar = "\u2007"; // "99:23:14" -> true
// "--:a3:14" -> false

var validTimeStringFormat = function validTimeStringFormat(timeString) {
  return /\d{2}:\d{2}:\d{2}/g.test(timeString);
};

var partsToMask = function partsToMask(parts) {
  // Get the mask string by iterating over the ordered array of parts
  var maskString = parts.map(function (_ref3) {
    var type = _ref3.type,
        value = _ref3.value,
        options = _ref3.options;

    switch (type) {
      case "hour":
        return "##";

      case "minute":
        return "##";

      case "second":
        return "##";

      case "dayPeriod":
        // Assume each day period option is the same length
        return "*".repeat(options[0].length);

      case "literal":
        return value;
    }
  }).join("");
  return new _mask["default"](maskString, {
    formatChars: {
      "#": "[0-9]",
      "*": "."
    },
    placeholderChar: placeholderChar
  });
}; // The TimePicker requires 2-digit format for hours, minutes, and seconds. We
// could force the "2-digit" setting on in the format object we pass to the
// Intl.DateTime APIs, but some browsers and versions of Node ignore the 2-digit
// format option for the "hour" field when in 12 hour mode.


var forceTwoDigit = function forceTwoDigit(part) {
  return part.type === "hour" || part.type === "minute" || part.type === "second" ? _objectSpread(_objectSpread({}, part), {}, {
    value: part.value ? (0, _padStart["default"])(part.value, 2, "0") : undefined,
    options: part.options ? part.options.map(function (option) {
      return (0, _padStart["default"])(option, 2, "0");
    }) : undefined
  }) : part;
};

var TimePicker = /*#__PURE__*/_react["default"].forwardRef(function (props, forwardedRef) {
  var value = props.value,
      format = props.format,
      onChange = props.onChange,
      idProp = props.id;
  var id = (0, _react.useMemo)(function () {
    return idProp || (0, _uniqueId["default"])("timepicker-");
  }, [idProp]); // HACK: Until we are able to localize Arabic numbers
  // we'll set Arabic to en-US. Currently the hours and AM/PM
  // are being localized into Arabic.

  var locale = props.locale == "ar-AE" ? "en-US" : props.locale;
  var inputRef = (0, _react.useRef)();
  var t = (0, _theme.useTheme)(_timePicker["default"], "timePicker");

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      focus = _useState2[0],
      setFocus = _useState2[1]; // [{ type: "hour", options: ["12", "01",...]}, { type: "literal", value: ":" }]


  var partOptions = (0, _react.useMemo)(function () {
    return (0, _timeParts.getPartOptions)(locale, format).map(forceTwoDigit);
  }, [locale, format]); // Position each part will appear in a formatted string
  // { hour: { start: 0, end: 1 }, dayPeriod: { start: 7, end: 8 } }

  var partPositions = (0, _react.useMemo)(function () {
    return (0, _timeParts.getPartPositions)(partOptions);
  }, [partOptions]); // All non literal options (used by TimePickerOptions)

  var nonLiteralOptions = (0, _react.useMemo)(function () {
    return partOptions.filter(function (_ref4) {
      var type = _ref4.type;
      return type !== "literal";
    });
  }, [partOptions]); // An "empty" string fallback. Used in onSelectOption to ensure we slice updated
  // values into the correct positions for the input value

  var placeholderInput = (0, _react.useMemo)(function () {
    return partOptions.map(function (_ref5) {
      var value = _ref5.value,
          options = _ref5.options;
      return value || placeholderChar.repeat(options[0].length);
    }).join("");
  }, [partOptions]); // The value of the Input

  var _useState3 = (0, _react.useState)(function () {
    if (value && validTimeStringFormat(value)) {
      return (0, _timeParts.timeStringToParts)(value, format, locale).map(forceTwoDigit).map(function (_ref6) {
        var value = _ref6.value;
        return value;
      }).join("");
    } else return "";
  }),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      inputValue = _useState4[0],
      setInputValue = _useState4[1]; // Ref memory of whether the last input was valid. Used in useEffect to determine
  // if we should clear the Input because of an outside state change, or keep the
  // invalid Input alive because it is still being updated


  var inputWasValid = (0, _react.useRef)(true);
  var mask = (0, _react.useMemo)(function () {
    return partsToMask(partOptions);
  }, [partOptions]); // Object of part values parsed from the current input
  // { hour: "10", minute: "--", second: "A3" }

  var partValues = (0, _react.useMemo)(function () {
    return (0, _timeParts.getPartValues)(inputValue, partPositions);
  }, [inputValue, partPositions]); // Check if every part's value exist in its given options

  var validInput = (0, _react.useMemo)(function () {
    var valid = true;

    var _loop = function _loop(part) {
      var _find = (0, _find2["default"])(partOptions, ["type", part]),
          options = _find.options;

      var partValue = partValues[part];
      var validOption = options.some(function (option) {
        return option.toLocaleLowerCase(locale) === partValue.toLocaleLowerCase(locale);
      });

      if (!validOption) {
        valid = false;
        return "break";
      }
    };

    for (var part in partValues) {
      var _ret = _loop(part);

      if (_ret === "break") break;
    }

    inputWasValid.current = valid;
    return valid;
  }, [partValues, partOptions, locale]); // If the _prop value_ changes and is valid, parse into parts and update
  // _input value_

  var previousValue = (0, _react.useRef)(value);
  (0, _react.useEffect)(function () {
    if (value !== previousValue.current) {
      if (value && validTimeStringFormat(value)) {
        var parts = (0, _timeParts.timeStringToParts)(value, format, locale).map(forceTwoDigit);
        var next = parts.map(function (_ref7) {
          var value = _ref7.value;
          return value;
        }).join("");
        setInputValue(next);
      } // If the last _input value_ was valid, but the current _prop value_ is
      // not, clear input value. Else, let the input value ride until it _is_
      // valid.
      else if (inputWasValid.current) {
        setInputValue("");
      }

      previousValue.current = value;
    }
  }, [value, format, locale]); // If the _input value_ changes and is valid, parse into parts and update
  // _state value_

  var previousInputValue = (0, _react.useRef)(inputValue);
  (0, _react.useEffect)(function () {
    if (inputValue !== previousInputValue.current) {
      if (validInput) {
        onChange((0, _timeParts.partsToTimeString)(partValues, partOptions, format, locale));
      } else if (value) {
        onChange("");
      }

      previousInputValue.current = inputValue;
    }
  }, [partValues, partOptions, format, locale, validInput, onChange, inputValue, value]); // Update input string when a user selects an option

  var onSelectOption = (0, _react.useCallback)(function (type, value) {
    // Fall back to the placeholder input so we slice the values into the correct spots
    var string = inputValue || placeholderInput;
    var _partPositions$type = partPositions[type],
        start = _partPositions$type.start,
        end = _partPositions$type.end;
    setInputValue("".concat(string.slice(0, start)).concat(value).concat(string.slice(end)));
  }, [partPositions, inputValue, placeholderInput]); // Clear input if the user changes focus and without constructing a valid time

  var onBlur = (0, _react.useCallback)(function () {
    setFocus(false);
    if (!validInput) setInputValue("");
  }, [validInput]);
  var onFocus = (0, _react.useCallback)(function () {
    setFocus(true); // HACK: Move cursor to beginning on focus if the value is empty.
    // This _should_ be doable in React input mask but, sadly, is not working 😢 https://github.com/sanniassin/react-input-mask/tree/2.0.4#beforemaskedvaluechange--function
    // This waits a beat for input mask to add its value before moving the cursor.

    if (!value) setTimeout(function () {
      return inputRef.current.setSelectionRange(0, 0);
    }, 0);
  }, [value]);
  var assignRefs = (0, _react.useCallback)(function (inputNode) {
    inputRef.current = inputNode;
    if (forwardedRef) forwardedRef.current = inputNode;
  }, [forwardedRef]);
  var invalidPopoverOpen = focus && inputValue && !inputValue.includes(placeholderChar) && !validInput;
  var passThroughProps = (0, _filterPropsByPrefix["default"])(props, ["data-", "aria-"]); // If there is not helperText, constraintText, or errorMessage
  // then the aria-describedby is empty.

  var ariaDescribedbyValue = (0, _getSupportTextAriaDescribedby["default"])({
    id: id,
    hasHelperText: !!props.helperText,
    hasConstraintText: !!props.constraintText,
    hasErrorMessage: !!props.errorMessage,
    errorMessageFirst: props.size === "xlarge"
  });
  return /*#__PURE__*/_react["default"].createElement(_supportTextWrapper["default"], {
    id: id,
    helperText: props.helperText,
    constraintText: props.constraintText,
    errorMessage: props.errorMessage,
    helperBelowFormField: props.size === "xlarge",
    className: widthStyles({
      width: props.width
    })
  }, /*#__PURE__*/_react["default"].createElement(_timePickerPopover["default"], {
    valueFilled: Boolean(value),
    onBlur: onBlur,
    onFocus: onFocus,
    width: props.width,
    disabled: props.disabled,
    anchor: function anchor(_ref8) {
      var onFocus = _ref8.onFocus,
          onBlur = _ref8.onBlur,
          popoverIsOpen = _ref8.popoverIsOpen;
      return /*#__PURE__*/_react["default"].createElement(_input["default"], (0, _extends2["default"])({
        ref: assignRefs,
        value: inputValue,
        onChange: setInputValue,
        disabled: props.disabled,
        error: props.error,
        placeholder: props.placeholder,
        focus: popoverIsOpen ? true : undefined,
        label: props.label,
        id: id,
        size: props.size,
        mask: mask,
        width: props.width,
        minWidth: props.minWidth,
        onBlur: onBlur,
        onFocus: onFocus,
        className: inputStyles(t, {
          filled: Boolean(inputValue),
          focus: focus
        }),
        suffix: props.suffix,
        suffixIconTokens: {
          // HACK: Keep the clock icon width & height to ensure the input
          // size doesn't change when switching icons.
          iconWidth: _clock["default"].iconClockWidth,
          iconHeight: _clock["default"].iconClockHeight,
          iconData: invalidPopoverOpen ? _alertErrorSmall["default"].iconAlertErrorSmallData : props.showIcon ? _clock["default"].iconClockData : undefined
        },
        "aria-describedby": ariaDescribedbyValue
      }, passThroughProps), focus ? /*#__PURE__*/_react["default"].createElement(_inputMonospacePlaceholder["default"], {
        t: t,
        mask: mask,
        disabled: props.disabled,
        value: inputValue
      }) : undefined, /*#__PURE__*/_react["default"].createElement(_timePickerInvalidPopover["default"], {
        inputRef: inputRef,
        t: t,
        open: Boolean(invalidPopoverOpen)
      }, props.invalidInputMessage));
    }
  }, function (_ref9) {
    var anchorRect = _ref9.anchorRect;
    return /*#__PURE__*/_react["default"].createElement(_timePickerOptions["default"], {
      options: nonLiteralOptions,
      values: partValues,
      onSelectOption: onSelectOption,
      minWidth: anchorRect.width
    });
  }), " ");
});

TimePicker.displayName = "TimePicker";
TimePicker.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * All props prefixed with `aria-` are accepted. This is useful for adding [aria
   * attributes](https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA) for improved accessibility.
   *
   * If adding a label with `aria-label`, first consider using the `label` prop
   * which will add a visible label and set the size to `xlarge`.
   *
   * If `constraintText`, `helperText`, and/or an `errorMessage` are provided to
   * the TimePicker these will be used to generate the `aria-describedby` prop.
   * This can be overridden by explicitly setting `aria-describedby` on the TimePicker.
   *
   * @since 5.10.1
   */
  "aria-*": _propTypes["default"].string,

  /**
   * Add constraint text to provide critical information regarding time picker content.
   *
   * @since 5.22.0
   */
  constraintText: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node]),

  /**
   * All props prefaced with `data-` are accepted. This is useful for adding selectors
   * for integrating with other libraries such as Amplify Analytics or Cypress
   *
   * @since 5.10.1
   */
  "data-*": _propTypes["default"].string,

  /**
   * This disables interaction with the component and applies special visual
   * styles to indicate that it's not interactive.
   */
  disabled: _propTypes["default"].bool,

  /**
   * Show the component in an error state. Use this to indicate that the value
   * of the component is invalid.
   *
   * Consider pairing this state with an `errorMessage`.
   */
  error: _propTypes["default"].bool,

  /**
   * An explanation for why the error state has occurred.
   * This will show as an xsmall [Alert](https://meridian.a2z.com/components/alert/) below the TimePicker.
   *
   * @since 5.22.0
   */
  errorMessage: _propTypes["default"].string,

  /**
   * The format of the time. See [Intl.DateTimeFormat](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat/DateTimeFormat) for available values.
   *
   * NOTE: The "hour", "minute", and "second" fields will all be formatted as
   * "2-digit" regardless of the format passed in here.
   *
   * NOTE: This cannot be changed after the component is mounted.
   */
  format: _propTypes["default"].object,

  /**
   * Add helper text to provide additional instruction.
   *
   * @since 5.22.0
   */
  helperText: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node]),

  /**
   * Sets an `id` attribute on the component's form element.
   *
   * Use this for testing or for accessibility. Do not use this in order to apply override styles
   * to the component. The markup and styles rendered by Meridian components
   * are private APIs, and may change without notice.
   */
  id: _propTypes["default"].string,

  /**
   * The message that appears when a user inputs an invalid time. We recommend including the field name and details on how to correct the error for improved accessibility for screen-reader users.
   */
  invalidInputMessage: _propTypes["default"].string,

  /**
   * A label for the input.
   *
   * If this prop is provided the `size` prop will be ignored and set to `xlarge`.
   */
  label: _propTypes["default"].string,

  /**
   * The locale to use when rendering times. See the [Intl API](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl) for more information
   * about date internationalization in JS.
   */
  locale: _propTypes["default"].oneOf(Object.keys(_dateLocales["default"])),

  /**
   * Set the minimum width of the component using a number (which will be treated
   * as pixels) or a string containing any valid CSS dimension.
   */
  minWidth: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),

  /**
   * Text that is shown in place of the select's value when nothing is selected.
   *
   * This text is not visible when an option is selected, so it should
   * not contain essential information that should be persisted. For that,
   * consider using the `label` prop.
   */
  placeholder: _propTypes["default"].string,

  /**
   * Sets the maximum height of the popover containing the select's options.
   * This is helpful if you have a very long list of options but don't want
   * to show a very tall popover. The option list is scrollable, so any
   * options that overflow the popover will still be accessible.
   */
  popoverMaxHeight: _propTypes["default"].number,

  /**
   * Set to false to hide the clock icon from the input.
   */
  showIcon: _propTypes["default"].bool,

  /**
   * Sets the size of the component using a preset.
   *
   * If the `label` prop is provided this prop will be ignored (the label
   * requires a particular amount of space which is not configurable).
   */
  size: _propTypes["default"].oneOf(["small", "medium", "large", "xlarge"]),

  /**
   * Static text to show in an end-cap appended to the component.
   *
   * To add a selectable suffix, see the `InputGroup` component.
   */
  suffix: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node]),

  /**
   * The value of the currently selected time option in the format HH:mm:ss (ex. "23:50:10")
   *
   * Update this when `onChange` is called to ensure the component is interactive
   * (see the documentation for the `onChange` prop).
   */
  value: _propTypes["default"].string,

  /**
   * Set the width of the component using a number (which will be treated
   * as pixels) or a string containing any valid CSS dimension.
   */
  width: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),

  /**
   * A function that will be called when the user attempts to change the value
   * of the component (e.g. by selecting an option). The new value will be
   * passed as the first argument to this function.
   *
   * Meridian uses [controlled components](https://reactjs.org/docs/forms.html#controlled-components),
   * so you must track the values provided to this function somewhere in state
   * and pass them back via the `value` prop in order to make this component
   * interactive.
   */
  onChange: _propTypes["default"].func
} : {};
TimePicker.defaultProps = {
  format: {
    hour: "2-digit",
    minute: "2-digit"
  },
  showIcon: true,
  size: "medium",
  locale: "en-US",
  invalidInputMessage: "This value is not a valid time."
};
var _default = TimePicker;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@amzn/meridian/time-picker/time-picker.js
// module id = 866
// module chunks = 0